import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
} from "reactstrap"
import { connect } from "react-redux"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import EditableColumn from "./EditableColumn"
import MwSelect from "../../components/Common/MwSelect"
import { withRouter } from "react-router-dom"
import Toaster from "../../components/Common/Toaster"
import * as backend from "../../helpers/backend_helper"
import Select from "react-select"
import _ from "lodash"

const uid = () => "u" + Math.random().toString(36).slice(2, 10) + (Date.now() % 100000).toString(36)
const withUids = (groups: any[]) =>
  (groups || []).map((g: any) => ({
    ...g,
    _uid: g._uid || uid(),
    lists: (g.lists || []).map((l: any) => ({ ...l, _uid: l._uid || uid() })),
  }))

// Redux Store

const StatutoryReport = (props: any) => {
  // console.log("props", props)

  const {
    match: {
      params: { orgId, facId },
    },
  } = props

  const [reports, setReports] = useState<any[]>([])
  const [userOptions, setUserOptions] = useState<any[]>([])

  // add group
  function addGroup() {
    setReports([...reports, { name: null, lists: [], _uid: uid() }])
  }

  // `field`/`data` let this same editor drive either the Monthly "Document
  // Review" (statutoryReport) or the Daily "Document Review" (dailyDocumentReview).
  const configField = props.field || "statutoryReport"
  // Daily keeps the original "Target time" (with a time value); Monthly uses the
  // new "Expiry Date" (Y/N only), per MW.pptx.
  const isDaily = configField === "dailyDocumentReview"

  useEffect(() => {
    setReports(withUids(props.data || props.statutoryReport || []))
  }, [])

  // Load org users so each document point can be assigned to specific users.
  // Inactive team members (teams[].status === false) are excluded from the list.
  useEffect(() => {
    const inactiveIds = new Set(
      ((props.factory && props.factory.teams) || [])
        .filter((t: any) => t.status === false)
        .map((t: any) => String(t.userId))
    )
    backend
      .getUserOrg(orgId)
      .then((users: any) =>
        setUserOptions(
          (users || [])
            .filter((u: any) => !inactiveIds.has(String(u._id)))
            .map((u: any) => ({ value: u._id, label: `${u.name} (${u.role})` }))
        )
      )
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, props.factory && props.factory._id])

  // on submit
  async function submit() {
    try {
      await backend.updateFactory(orgId, facId, {
        [configField]: reports,
      })
      props.update && props.update()
      Toaster.success("Document Review Updated Success")
    } catch (e) {
      console.log("statutoryReport error", e)
      Toaster.error("Statutory Report Updated Failed")
    }

    console.log(reports)
  }
  // remove group
  function removeGroup(idx) {
    const cloneList = [...reports]
    cloneList.splice(idx, 1)
    setReports([...cloneList])
  }

  // Drag: reorder groups, and reorder / move points within or across headers.
  function onDragEnd(result) {
    const { source, destination, type } = result
    if (!destination) return
    if (type === "group") {
      if (source.index === destination.index) return
      const clone = [...reports]
      const [moved] = clone.splice(source.index, 1)
      clone.splice(destination.index, 0, moved)
      setReports(clone)
      return
    }
    const fromG = reports.findIndex(g => g._uid === source.droppableId)
    const toG = reports.findIndex(g => g._uid === destination.droppableId)
    if (fromG < 0 || toG < 0) return
    if (fromG === toG && source.index === destination.index) return
    const clone = [...reports]
    const fromLists = [...clone[fromG].lists]
    const [moved] = fromLists.splice(source.index, 1)
    if (fromG === toG) {
      fromLists.splice(destination.index, 0, moved)
      clone[fromG] = { ...clone[fromG], lists: fromLists }
    } else {
      const toLists = [...clone[toG].lists]
      toLists.splice(destination.index, 0, moved)
      clone[fromG] = { ...clone[fromG], lists: fromLists }
      clone[toG] = { ...clone[toG], lists: toLists }
    }
    setReports(clone)
  }

  function addSubList(id) {
    const cloneList = [...reports]
    cloneList[id].lists = [
      ...cloneList[id].lists,
      { name: null, type: "select", _uid: uid() },
    ]
    setReports([...cloneList])
  }

  function updateGroupValue(e, key, idx) {
    const cloneList = [...reports]
    cloneList[idx][key] = e
    setReports([...cloneList])
  }

  function updateListValue(e, key, idx, liIndex) {
    const cloneList = [...reports]
    const list = cloneList[idx].lists[liIndex]
    if (list) {
      list[key] = e
    }
    setReports([...cloneList])
  }

  function onDelete(idd, subIndex) {
    const cloneList = [...reports]

    console.log("idd, subIndex", idd, subIndex, reports)

    const list = cloneList[idd].lists

    list.splice(subIndex, 1)
    console.log("cloneListcloneList", cloneList)
    setReports([...cloneList])
  }

  const SubListRender = (sublist, subIndex, idd) => (
    <React.Fragment>
      <Row>
        <Col lg={5}>
          <EditableColumn
            value={sublist.name}
            update={e => updateListValue(e, "name", idd, subIndex)}
          />
        </Col>
        <Col lg={4}>
          {!sublist.isHeader && (
            <MwSelect
              value={sublist.type}
              placeholder="Type"
              onChange={(val: any) => updateListValue(val, "type", idd, subIndex)}
              options={[
                { value: "input", label: "Input" },
                { value: "select", label: "Select" },
              ]}
            />
          )}
        </Col>
        <Col lg={2}>
          <Label check>
            <Input
              checked={sublist.isHeader}
              type="checkbox"
              onChange={e =>
                updateListValue(e.target.checked, "isHeader", idd, subIndex)
              }
            />{" "}
            isHeader
          </Label>
        </Col>
        <Col lg={1}>
          <button
            onClick={e => onDelete(idd, subIndex)}
            type="button"
            className="btn btn-danger waves-effect waves-light"
          >
            <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
          </button>
        </Col>
      </Row>
      {/* Assign this document to specific users. Non-admin users only see the
          documents assigned to them; admins see everything. Empty = visible to all. */}
      {!sublist.isHeader && (
        <Row className="mt-1 mb-2">
          <Col lg={2} className="d-flex align-items-center">
            <small className="text-muted">Assign to</small>
          </Col>
          <Col lg={9}>
            <Select
              isMulti
              placeholder="All users (unassigned)"
              value={_.filter(userOptions, o =>
                (sublist.assignedUsers || []).includes(o.value)
              )}
              options={userOptions}
              classNamePrefix="select2-selection"
              onChange={(selected: any) =>
                updateListValue(
                  (selected || []).map((s: any) => s.value),
                  "assignedUsers",
                  idd,
                  subIndex
                )
              }
            />
          </Col>
        </Row>
      )}
      {/* Daily: "Target time" (Y/N → pick a time, original behaviour).
          Monthly: "Expiry Date" (Y/N only); when "No", the Expiry Date column
          is hidden for this document on the Document Review page. (MW.pptx) */}
      {!sublist.isHeader && (
        <Row className="mt-1 mb-2">
          <Col lg={2} className="d-flex align-items-center">
            <small className="text-muted">{isDaily ? "Target time" : "Expiry Date"}</small>
          </Col>
          <Col lg={9}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ width: 110 }}>
                <MwSelect
                  value={sublist.targetTime || ""}
                  placeholder="Y/N"
                  onChange={(val: any) => {
                    updateListValue(val, "targetTime", idd, subIndex)
                    if (val !== "yes") updateListValue("", "targetTimeValue", idd, subIndex)
                  }}
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                />
              </div>
              {isDaily && sublist.targetTime === "yes" && (
                <Input
                  type="time"
                  value={sublist.targetTimeValue || ""}
                  onChange={(e) => updateListValue(e.target.value, "targetTimeValue", idd, subIndex)}
                  style={{ maxWidth: 140 }}
                />
              )}
            </div>
          </Col>
        </Row>
      )}
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <Container fluid>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={addGroup}
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            New Group
          </button>
        </div>
        <br />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="groups" type="group">
                {gprov => (
                <ul
                  className="list-unstyled"
                  style={{ height: "60vh", overflow: "auto" }}
                  ref={gprov.innerRef}
                  {...gprov.droppableProps}
                >
                  {reports.map((report, idd) => (
                    <Draggable key={report._uid} draggableId={`group-${report._uid}`} index={idd}>
                    {gp => (
                    <li ref={gp.innerRef} {...gp.draggableProps}>
                      <div
                        className="factory-monitoring-group-list"
                        style={{ textAlign: "start" }}
                      >
                        <Row className="align-items-center">
                          <Col md={1}>
                            <i
                              className="mdi mdi-drag-vertical"
                              title="Drag to reorder group"
                              style={{ cursor: "grab", fontSize: "22px", color: "#1D3A5F" }}
                              {...gp.dragHandleProps}
                            />
                          </Col>
                          <Col md={10}>
                            <EditableColumn
                              value={report.name}
                              update={e => updateGroupValue(e, "name", idd)}
                            />
                          </Col>
                          {/* <Col lg={1} md={1}>
                            <button
                              onClick={e => addSubList(idd)}
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                            >
                              ADD
                            </button>
                          </Col> */}
                          <Col md={1}>
                            <button
                              onClick={e => removeGroup(idd)}
                              type="button"
                              className="btn btn-danger waves-effect waves-light"
                            >
                              <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                            </button>
                          </Col>
                        </Row>
                      </div>
                      <Droppable droppableId={report._uid} type="point">
                      {(pprov, psnap) => (
                      <ul
                        className="list-unstyled"
                        ref={pprov.innerRef}
                        {...pprov.droppableProps}
                        style={{ minHeight: 12, background: psnap.isDraggingOver ? "#eef7f5" : "transparent", borderRadius: 8 }}
                      >
                        {report.lists.map((sublist, subIndex) => (
                          <Draggable key={sublist._uid} draggableId={`point-${sublist._uid}`} index={subIndex}>
                          {dp => (
                          <li ref={dp.innerRef} {...dp.draggableProps} style={{ padding: "10px", ...dp.draggableProps.style }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <i
                                className="mdi mdi-drag-vertical"
                                title="Drag to reorder / move to another header"
                                style={{ cursor: "grab", fontSize: "20px", color: "#8a97a8", marginRight: "8px" }}
                                {...dp.dragHandleProps}
                              />
                              <div style={{ flex: 1 }}>
                                {SubListRender(sublist, subIndex, idd)}
                              </div>
                            </div>
                          </li>
                          )}
                          </Draggable>
                        ))}
                        {pprov.placeholder}
                      </ul>
                      )}
                      </Droppable>

                      <Col
                        lg={10}
                        md={10}
                        style={{ textAlign: "center", padding: "24px 0px" }}
                      >
                        <button
                          onClick={e => addSubList(idd)}
                          type="button"
                          className="btn btn-primary waves-effect waves-light"
                        >
                          ADD
                        </button>
                      </Col>
                    </li>
                    )}
                    </Draggable>
                  ))}
                  {gprov.placeholder}
                </ul>
                )}
                </Droppable>
                </DragDropContext>
                {reports.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button onClick={submit} color="success">
                      Submit
                    </Button>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default withRouter(connect(null, {})(StatutoryReport))
